<template>
  <div id = "app" class = "container-fluid">
    <router-view></router-view>
  </div>
</template>

<script lang = "babel">
  export default {
    name: 'App',

    created () {
      this.$root.$on('temporary-problem', () => {
        this.$router.push('/temporary-problem')
      })

      this.$root.$on('error', () => {
        this.$router.push('/error')
      })

      this.$root.$on('unauthorized', () => {
        this.$router.push('/access-denied')
      })
    }
  }

</script>

<style lang = "scss">
  @import '../node_modules/bootstrap/dist/css/bootstrap.css';
  @import '../node_modules/flatpickr/dist/flatpickr.css';
  @import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';

  // assuming tooltip only be used for errors
  .tooltip-inner {
    background-color: #f00;
  }

  .tooltip.bs-tooltip-right .arrow::before {
    border-right-color: #f00;
  }

  .modal-body {
    max-height: calc(100vh - 210px);
    overflow-y: auto;
  }

  .has-danger {
    color: red;

    input {
      border: 1px solid red;
    }

    a {
      color: red;
    }
  }

</style>



// WEBPACK FOOTER //
// App.vue?31c948c3